import { Component, OnInit } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { iframeUrl } from 'src/app/core/constant/iframeUrls';

@Component({
  selector: 'app-pending-users',
  templateUrl: './pending-users.component.html',
  styleUrls: ['./pending-users.component.scss']
})
export class PendingUsersComponent implements OnInit {
  iframeUrlActivationPendingUsers: any;

  constructor(
    private sanitizer: DomSanitizer,
    private router: Router
  ) {

  }

  ngOnInit(): void {
    let iframeUrlActivationPendingUsersRaw = iframeUrl.activationPendingUsers.url;
    this.iframeUrlActivationPendingUsers = this.sanitizer.bypassSecurityTrustResourceUrl(iframeUrlActivationPendingUsersRaw);
  }

  BackToDashboard() {
    this.router.navigate(['dashboard']);
  }

}
